import { TICKET } from 'customer-data-objects/constants/ObjectTypes';
import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ManageSeatsLink } from './ManageSeatsLink';
import BannerContent from './BannerContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RotateOwnerSeatsBanner = ({
  children,
  objectTypeId,
  onClose
}) => {
  if (objectTypeId === TICKET || objectTypeId === TICKET_TYPE_ID) {
    return /*#__PURE__*/_jsx(BannerContent, {
      onClose: onClose,
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          ManageSeatsLink
        },
        message: "routing-ui.routingRules.roundRobin.manageRotateOwnerTicketSeats_jsx"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
RotateOwnerSeatsBanner.displayName = 'RotateOwnerSeatsBanner';